import * as React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  register: () => void;
  isLogged?: boolean;
}

const FollowUpComponent: React.StatelessComponent<Props> = (props: Props) => (
  <div className="tab-content padding-40">
    <div className="row">
      <div className="col-sm-6">
        <p>
          <strong>Recibe informes trimestrales de tus inversiones</strong>
        </p>
        <div className="gap-20"/>
        <p>
          The Crowd Angel genera y distribuye a los inversores informes trimestrales de negocio y financieros de sus
          participadas, para que siempre estés al corriente de la evolución de tus inversiones. En el apartado
          “Mi Cartera” puedes encontrar toda la documentación sobre tus inversiones.
        </p>
      </div>
      <div className="col-sm-6 text-center">
        <img
          style={{width: '490px', height: '245px'}}
          alt="informes trimestrales"
          src="/img/09_informes_trimestrales.png"
        />
      </div>
    </div>
    <div className="gap-50"/>
    <div className="row">
      <div className="col-sm-6 text-center">
        <img
          style={{width: '520px', height: '260px'}}
          alt="representacion consejo y junta"
          src="/img/10_representacion_consejo_junta.png"
        />
      </div>
      <div className="col-sm-6">
        <p>
          <strong>Representación en Consejo de Administración y Junta</strong>
        </p>
        <div className="gap-20"/>
        <p>
          El grupo de inversores sindicados que participan en cada inversión contará con un representante para defender
          los intereses del grupo en la Junta de Accionistas y en el Consejo de Administración de cada compañía.
          El equipo The Crowd Angel también participará como observador en los dos órganos de control para apoyar en el
          crecimiento de las compañías.
        </p>
      </div>
    </div>
    <div className="gap-50"/>
    <div className="row">
      <div className="col-sm-6">
        <p>
          <strong>Acompañamiento hasta la desinversión</strong>
        </p>
        <div className="gap-20"/>
        <p>
          The Crowd Angel te acompañará y gestionará la relación entre las empresas y los inversores durante todo el
          tiempo en el que seas inversor hasta que llegue el momento de la desinversión. Podrás seguir reinvirtiendo en
          las empresas con mayor tracción de tu cartera, y nosotros te mantendremos al corriente de cualquier firma o
          gestión referente a tu inversión.
        </p>
      </div>
      <div className="col-sm-6 text-center">
        <img
          style={{width: '440px', height: '220px'}}
          alt="desinversion"
          src="/img/11_desinversion.png"
        />
      </div>
    </div>
    <div className="gap-50"/>
    <p className="text-center">
      {props.isLogged ?
        <Link to={'/invertir'}>
          <button className="btn btn-secondary btn-lg">
            Invertir
          </button>
        </Link> :
        <button
          className="btn btn-secondary btn-lg"
          onClick={() => props.register()}
        >
          Registrarse
        </button>
      }
    </p>
  </div>
);

export default FollowUpComponent;



// WEBPACK FOOTER //
// ./src/modules/how-to-invest/partials/FollowUp.component.tsx